import DashboardActionTypes from './dashboard-types'

const INITIAL_STATE = {
    dashboard: null,
    loader: null,
}

const dashboardReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case DashboardActionTypes.START_FETCH_DASHBOARDS:
            return {
                ...state,
                loader: { ...state.loader, FETCH_DASHBOARDS: true },
            }
        case DashboardActionTypes.SUCCESS_FETCH_DASHBOARDS:
            return {
                ...state,
                dashboard: action.payload,
                loader: { ...state.loader, FETCH_DASHBOARDS: null },
            }
        default:
            return state
    }
}

export default dashboardReducer
